import { useState, useEffect } from "react";

const LeftSidebar = ({ pageProps }) => {
  const { adherenceSidebar } = pageProps;
  const menuLinks = adherenceSidebar?.fields?.menuLinks;
  const [activeLink, setActiveLink] = useState(null);
  const [isMobile, setIsMobile] = useState(false);

  useEffect(() => {
    // check active link
    const pathname = removeLocaleFromHref(window?.location?.pathname);
    const activeLink = menuLinks?.find((item) => removeLocaleFromHref(item?.fields?.link?.href) === pathname);
    setActiveLink(activeLink);

    const handleResize = () => {
      setIsMobile(window.innerWidth < 1024);
    }
    handleResize();
    window.addEventListener("resize", handleResize);
    return () => window.removeEventListener("resize", handleResize);
  }, []);

  const removeLocaleFromHref = (href) => {
    return href.replace("/en/", "/").replace("/fr/", "/");
  }

  return (
    <div className="lg:tw-absolute lg:tw-top-0 lg:tw-left-0 lg:tw-h-full lg:tw-w-60 tw-w-full tw-z-50 lg:tw-p-8 tw-p-6 lg:tw-border-r lg:tw-border-black/10 tw-bg-white">
      {!isMobile && <div className="tw-list-none">
        {!!menuLinks?.length && menuLinks.map((item) => {
          const link = item?.fields?.link;
          const isActive = activeLink?.contentID == item?.contentID;
          return (
            <div key={item} className="tw-border-t last:tw-border-b">
              <a 
                href={link?.href} 
                target={link?.target} 
                className={`tw-group tw-w-full tw-py-2 hover:tw-bg-primary-red tw-flex tw-items-start ${
                  isActive ? "tw-bg-primary-red" : ""
                }`}
                onClick={(e) => !!isActive && e.preventDefault()}
              >
                {!isActive && <span className="tw-mt-1.5 group-hover:tw-hidden"><ArrowRight/></span>}
                <span className={`tw-text-[13px] tw-text-black group-hover:tw-text-white tw-font-helv tw-font-bold tw-px-2 ${
                  isActive ? "tw-text-white" : ""
                }`}>
                  {link?.text}
                </span>
              </a>
            </div>
          )
        })}
      </div>}
      
    {isMobile && (
      <MobileMenuDropdown
        menuLinks={menuLinks}
        activeLink={activeLink}
        setActiveLink={setActiveLink}
      />
    )}
    </div>
  );
};

const ArrowRight = () => (
  <svg
    width="11"
    height="11"
    viewBox="0 0 11 11"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    xmlnsXlink="http://www.w3.org/1999/xlink"
  >
    <rect width="11" height="11" fill="url(#pattern0_1_1083)" />
    <defs>
      <pattern
        id="pattern0_1_1083"
        patternContentUnits="objectBoundingBox"
        width="1"
        height="1"
      >
        <use xlinkHref="#image0_1_1083" transform="scale(0.0909091)" />
      </pattern>
      <image
        id="image0_1_1083"
        width="11"
        height="11"
        preserveAspectRatio="none"
        xlinkHref="data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAsAAAALCAYAAACprHcmAAAAGXRFWHRTb2Z0d2FyZQBBZG9iZSBJbWFnZVJlYWR5ccllPAAAAyhpVFh0WE1MOmNvbS5hZG9iZS54bXAAAAAAADw/eHBhY2tldCBiZWdpbj0i77u/IiBpZD0iVzVNME1wQ2VoaUh6cmVTek5UY3prYzlkIj8+IDx4OnhtcG1ldGEgeG1sbnM6eD0iYWRvYmU6bnM6bWV0YS8iIHg6eG1wdGs9IkFkb2JlIFhNUCBDb3JlIDUuNi1jMDY3IDc5LjE1Nzc0NywgMjAxNS8wMy8zMC0yMzo0MDo0MiAgICAgICAgIj4gPHJkZjpSREYgeG1sbnM6cmRmPSJodHRwOi8vd3d3LnczLm9yZy8xOTk5LzAyLzIyLXJkZi1zeW50YXgtbnMjIj4gPHJkZjpEZXNjcmlwdGlvbiByZGY6YWJvdXQ9IiIgeG1sbnM6eG1wPSJodHRwOi8vbnMuYWRvYmUuY29tL3hhcC8xLjAvIiB4bWxuczp4bXBNTT0iaHR0cDovL25zLmFkb2JlLmNvbS94YXAvMS4wL21tLyIgeG1sbnM6c3RSZWY9Imh0dHA6Ly9ucy5hZG9iZS5jb20veGFwLzEuMC9zVHlwZS9SZXNvdXJjZVJlZiMiIHhtcDpDcmVhdG9yVG9vbD0iQWRvYmUgUGhvdG9zaG9wIENDIDIwMTUgKE1hY2ludG9zaCkiIHhtcE1NOkluc3RhbmNlSUQ9InhtcC5paWQ6MTQzRjA3QzA0OTgwMTFFNThBNjY5RjJCQjMwRThBNDYiIHhtcE1NOkRvY3VtZW50SUQ9InhtcC5kaWQ6MTQzRjA3QzE0OTgwMTFFNThBNjY5RjJCQjMwRThBNDYiPiA8eG1wTU06RGVyaXZlZEZyb20gc3RSZWY6aW5zdGFuY2VJRD0ieG1wLmlpZDoxNDNGMDdCRTQ5ODAxMUU1OEE2NjlGMkJCMzBFOEE0NiIgc3RSZWY6ZG9jdW1lbnRJRD0ieG1wLmRpZDoxNDNGMDdCRjQ5ODAxMUU1OEE2NjlGMkJCMzBFOEE0NiIvPiA8L3JkZjpEZXNjcmlwdGlvbj4gPC9yZGY6UkRGPiA8L3g6eG1wbWV0YT4gPD94cGFja2V0IGVuZD0iciI/Purae9IAAACFSURBVHjaYtTQ1KxnYGBoYCAMGhiBiv8zEAmYGEgAGIorKyoYRERFsSrGcMb1a9cYvn//zrBx40aGmbNmMbx48QK/Mzg5ORkiIiIYNm7YwGBqagoXZ8GmGGTy5s2bGWbMnMnw/Plz3IqXLFnCMHvOHIZXr14RdjPVgo4ZGkwOxMQgQIABAKeCKO6rW9idAAAAAElFTkSuQmCC"
      />
    </defs>
  </svg>

)

const MobileMenuDropdown = ({menuLinks, activeLink, setActiveLink}) => {
  const [isOpen, setIsOpen] = useState(false);
  const handleClick = () => setIsOpen(!isOpen);

  useEffect(() => {
    // outside click dismiss
    const handleOutsideClick = (event) => {
      if (event.target.closest(".m-menu-dropdown") || event.target.closest(".m-menu-dropdown-list")) return;
      setIsOpen(false);
    }
    document.addEventListener("click", handleOutsideClick);
    return () => document.removeEventListener("click", handleOutsideClick);

  }, [])

  return (
    <div className="m-menu-dropdown tw-w-full tw-relative">
      <button
        className="tw-w-full tw-flex tw-items-center tw-justify-between tw-gap-2 tw-border tw-border-grey-500 tw-rounded-lg tw-bg-white tw-px-3 tw-py-2 tw-text-sm tw-text-gray-700 hover:tw-bg-gray-50 focus:tw-outline-none focus:tw-ring-2 focus:tw-ring-blue-500"
        onClick={handleClick}
      >
        <span>{activeLink?.fields?.link?.text || "Navigation"}</span>
        <svg className={`tw-w-4 tw-h-4 tw-transition-transform ${isOpen ? "tw-rotate-180" : ""}`} id="dropdownIcon" fill="none" viewBox="0 0 24 24" stroke="currentColor">
          <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M19 9l-7 7-7-7" />
        </svg>
      </button>

      <ul className={`m-menu-dropdown-list tw-absolute tw-z-50 tw-mt-1 tw-w-full tw-rounded-lg tw-border tw-border-grey-500 tw-bg-white tw-overflow-hidden ${isOpen ? "tw-block" : "tw-hidden"}`}>
        {!!menuLinks?.length && menuLinks.map((item, idx) => {
          const link = item?.fields?.link;
          const isActive = activeLink?.contentID == item?.contentID;
          return (
            <li key={idx} className="tw-cursor-pointer tw-m-0 tw-p-0 tw-list-none">
              <a 
                href={link?.href} 
                target={link?.target} 
                className={`tw-px-3 tw-py-2 tw-inline-block tw-w-full ${isActive ? "tw-bg-primary-red" : "tw-bg-white"}`}
                onClick={(e) => {
                  !!isActive && e.preventDefault();
                  setIsOpen(false); 
                  setActiveLink(item);
                }}
              >
                <span className={`${isActive ? "tw-text-white" : "tw-text-black"} hover:tw-text-white tw-text-sm`}>
                  {link?.text}
                </span>
              </a>
            </li>
          );
        })}
      </ul>
    </div>
  )
}

export default LeftSidebar;
